import {
  Flex,
  useRadioGroupContext,
  Input,
  useRadio,
} from '@wegroup/design-system';
import React from 'react';
import RadioButton from '../../../../flows/src/components/ui/advisory-flow/components/shared-components/RadioButton';
import IllustrationButton from './IllustrationButton';

interface Props {
  Illustration: React.ReactElement;
  isDisabled?: boolean;
  value?: string;
  dataTestId?: string;
}

const IllustrationRadioButton: React.FC<React.PropsWithChildren<Props>> = ({
  Illustration,
  children,
  isDisabled = false,
  value,
  dataTestId = 'RISK-ANALYSIS_ILLUSTRATION-RADIO-BUTTON',
  ...otherProps
}) => {
  const { value: groupValue, onChange } = useRadioGroupContext();
  const isChecked = groupValue === value;
  const { getInputProps, getLabelProps } = useRadio({
    isChecked: isChecked,
    onChange: onChange,
    isDisabled: isDisabled,
    value: value,
  });

  return (
    <IllustrationButton
      Illustration={Illustration}
      inputElement={
        <>
          <Flex
            justifyContent="center"
            flexGrow={1}
            alignItems="flex-end"
            flexShrink={0}
          >
            <RadioButton isSelected={isChecked} />
          </Flex>
          <Input {...getInputProps()} />
        </>
      }
      dataTestId={dataTestId}
      {...getLabelProps()}
      {...otherProps}
    >
      {children}
    </IllustrationButton>
  );
};

export default IllustrationRadioButton;
